import styled from "styled-components";

export const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: auto;
`;

export const Header = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const Label = styled.label`
  font-weight: bold;
`;

export const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
`;

export const Select = styled.select`
  padding: 0.5rem;
  border: 1px solid #ccc;
`;

export const Textarea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid #ccc;
`;

export const ImovelCard = styled.div`
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;